import { calendar } from './content/calendar.ts';
import { byId } from './content/index.ts';
import { mapIndex } from './content/map-index.ts';
import { subjects } from './types.ts';
import type { Subject } from './types.ts';
import type { Notebook } from './notebook.ts';

/** Pure, repeatable reset. Question identity also removes pre-migration date aliases. */
export function resetNotebook(value: Notebook, date: string, subject?: Subject): Notebook {
  const schedule = calendar[date];
  if (!schedule) return value;
  const next = structuredClone(value);
  const p = next.progress;
  for (const item of subject ? [subject] : subjects) {
    if (item === 'maps') {
      const map = mapIndex[date];
      if (map) delete next.maps[map.storageKey];
      continue;
    }
    const exercise = byId[schedule[item]];
    const ids = new Set(
      [...exercise.questions, ...(exercise.retiredQuestions ?? [])].map((q) => q.id),
    );
    for (const records of [p.attempts, p.drafts]) {
      for (const key of Object.keys(records))
        if (ids.has(key.slice(key.lastIndexOf('/') + 1))) delete records[key];
    }
    p.history = p.history.filter((row) => !ids.has(row.questionId));
    for (const key of Object.keys(p.readingStarted))
      if (key.includes(exercise.id)) delete p.readingStarted[key];
    if (p.completions[date])
      p.completions[date] = p.completions[date].filter((category) => category !== item);
  }
  if (p.dailyStamps) delete p.dailyStamps[date];
  if (!subject) {
    delete p.completions[date];
    if (p.dailySubjects) delete p.dailySubjects[date];
    if (p.dailyConfirmed) delete p.dailyConfirmed[date];
  }
  return next;
}
